/* eslint-disable */
const state = () => ({
    openfolder:localStorage.getItem("openfolder"),
    folderId :  localStorage.getItem('folder'),
    folderName:localStorage.getItem('folderName'),
    lastModifiedAt:localStorage.getItem('Folderdate'),
    folderMoveId:localStorage.getItem('folderMoveId'),
    showDetails:false,
    showHideDetails: [],
    showHideFolderDetails:[],
    openfolderlist:[],
    newopenfolderlist:[],
    PrevRoute:"",
    SigningFrom:""
   });
   
   const getters = {
        getPrevRoute( state :{PrevRoute : any}){
           return state.PrevRoute;
            },
        getSigningFrom( state :{SigningFrom : any}){
           return state.SigningFrom;
            },
        getopenfolderlist( state :{openfolderlist : any}){
           return state.openfolderlist;
            },
        getnewopenfolderlist( state :{newopenfolderlist : any}){
           return state.newopenfolderlist;
            },
        getFolderId( state :{folderId : any}){
           return state.folderId;
            },
        getFolderName( state :{folderName : any}){
        return state.folderName;
            },
        getFolderdate( state :{lastModifiedAt : any}){
            return state.lastModifiedAt;
        },
        getDetails( state :{showDetails : boolean}){
            return state.showDetails;
        },
        getShowDetails( state :{showHideDetails : any}){
            return state.showHideDetails;
        },     
        getFolderMoveId( state :{folderMoveId : any}){
            return state.folderMoveId;
        },
        getopenfolder(state: { openfolder: any }) {
		return state.openfolder;
	},
   };
   
   const actions ={
    async setSigningFrom({commit} : any , data : any){
        commit("setSigningFrom" , data);
    },
    async setPrevRoute({commit} : any , data : any){
        commit("setPrevRoute" , data);
    },
    async setopenfolderlist({commit} : any , data : any){
        commit("setopenfolderlist" , data);
    },
    async setnewopenfolderlist({commit} : any , data : any){
        commit("setnewopenfolderlist" , data);
    },
    async setShowDetails({commit} : any , data : any){
        commit("setShowDetails" , data);
    },
    async setopenfolder({ commit }: any, data: any) {
		commit("setopenfolder", data);
	},
    async setFolderDetails({commit} : any , data : any){
        commit("setFolderDetails" , data);
    },
    async setFolderMoveId({commit} : any , data : any){
        commit("setFolderMoveId" , data);
    },
        async setFolderId({commit} : any , data : any){
            commit("setFolderId" , data);
        },
        async setFolderName({commit} : any , data : any){
        commit("setFolderName" , data);
        },
        async setFolderdate({commit} : any , data : any){
            commit("setFolderdate" , data);
        },
        async setDetails({commit} : any , data : boolean){
            commit("setDetails" , data);
        }   
   };
   
   const mutations ={
    //openfolderlist
    setPrevRoute(state: { PrevRoute: any }, PrevRoutedata: any) {
		state.PrevRoute = PrevRoutedata;
	},
    setSigningFrom(state: { SigningFrom: any }, SigningFromdata: any) {
		state.SigningFrom = SigningFromdata;
	},
    setopenfolderlist(state: { openfolderlist: any }, openfolderlistdata: any) {
		state.openfolderlist = openfolderlistdata;
	},
    setnewopenfolderlist(state: { newopenfolderlist: any }, newopenfolderlistdata: any) {
		state.newopenfolderlist = newopenfolderlistdata;
	},
    setopenfolder(state: { openfolder: any }, openfolders: any) {
		state.openfolder = openfolders;
		localStorage.setItem("openfolder", openfolders);
	},
    setShowDetails(state : {showHideDetails : any } , showData : any ){
        state.showHideDetails = showData;
     },
     setFolderDetails(state : {showHideFolderDetails : any } , showFolderData : any ){
        state.showHideFolderDetails = showFolderData;
     },
     setFolderMoveId(state : {folderMoveId : any } , folderMovedId : any ){
        state.folderMoveId = folderMovedId;
        localStorage.setItem("folderMoveId", folderMovedId);
     },
        setFolderId(state : {folderId : any } , folderData : any ){
           state.folderId = folderData;
           localStorage.setItem("folder", folderData);
        },
       setFolderName(state : {folderName : any } , folderNameData : any ){
        state.folderName = folderNameData;
        localStorage.setItem("folderName", folderNameData);
        },
        setFolderdate(state : {lastModifiedAt : any } , lastModifiedAt : any ){
            state.lastModifiedAt = lastModifiedAt;
            localStorage.setItem("folderdate", lastModifiedAt);
        },
        setDetails(state : {showDetails : boolean } , showDetailsData : any ){
            state.showDetails = showDetailsData;
            localStorage.setItem("showDetails", showDetailsData);
        }
    };
   
   export default {
       state,
       getters,
       actions,
       mutations
   }